import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { InvoicingServiceService } from "../../services/invoicing-service.service";
import { IInvoicingServiceData } from "../../model/invoicing-service-data";

@Component({
  selector: 'app-pub-invoicing-services-detail',
  templateUrl: './pub-invoicing-services-detail.component.html',
  styleUrls: ['./pub-invoicing-services-detail.component.css']
})
export class PubInvoicingServicesDetailComponent implements OnInit {

  /**
   * @type {string}
   */
  slug: string;

  /**
   * @type {boolean}
   */
  load: boolean;


  /**
   * Detail of IInvoicingServiceData
   */
  invoicingServiceSlug: IInvoicingServiceData;

  /**
   *
   * @param {ActivatedRoute} route
   * @param {InvoicingServiceService} invoicingServiceService
   */
  constructor(private route: ActivatedRoute,
              private invoicingServiceService: InvoicingServiceService,) { }

  /**
   * ngOnInit
   */
  ngOnInit() {
    this.load = false;
    this.slug = this.route.snapshot.paramMap.get('identifier');

    this.invoicingServiceService.getDataInvoicingServiceSlug(this.slug)
      .subscribe(result => {
        this.invoicingServiceSlug = result;
        this.load = true;
      });
  }

  getApplicationClass(applicationName: string): string {
    return 'fa-' + applicationName;
  }

  getApplicationTitle(applicationName: string): string {
    return 'pub.listComponent.' + applicationName;
  }
}



// WEBPACK FOOTER //
// ./src/app/app-public/pub-invoicing-services-detail/pub-invoicing-services-detail.component.ts